export default __webpack_public_path__ + "static/media/icon-desktopupload-gray.564958ba.svg";